/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import SwapsTokenSearch from './SwapsTokenSearch'

export default function SwapsTokenSelect({
  setToken,
  open,
  setOpen,
  tokenList
}) {
  const [results, setResults] = useState()

  useEffect(() => {
    setResults(tokenList)
  }, [tokenList])

  const handleTokenSelect = (e, token) => {
    e.preventDefault()
    setToken(token)
    setOpen(false)
  }

  const filterTokens = symbol => {
    return tokenList.find(token => {
      return token.symbol === symbol
    })
  }

  const handleCommonBase = (e, token) => {
    e.preventDefault()
    let filteredToken = filterTokens(token)
    if (filteredToken) {
      setToken(filteredToken)
      setOpen(false)
    }
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={setOpen}
      >
        <div className="flex items-end justify-center min-h-screen text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 p-6">
              <div className="sm:flex sm:items-start">
                <div className="mt-3 sm:mt-0 sm:ml-4 sm:mr-4 sm:text-left w-full">
                  <Dialog.Title
                    as="h3"
                    className="text-lg leading-6 font-medium text-gray-900"
                  >
                    Select a token
                  </Dialog.Title>
                  <div className="flex mt-5">
                    <SwapsTokenSearch
                      tokenList={tokenList}
                      results={results}
                      setResults={setResults}
                    />
                  </div>
                  <div className="mt-3">
                    <div className="block text-sm mb-3">Common bases</div>

                    <div className="flex flex-wrap">
                      <div
                        className="flex cursor-pointer hover:bg-gray-50 pl-2 rounded rounded-full pt-1 pb-1 pr-1 mr-1 border"
                        onClick={e => handleCommonBase(e, 'MATIC')}
                      >
                        <div className="flex items-center">
                          <img
                            src="https://polygonscan.com/token/images/matic_32.png"
                            className="w-7 h-7"
                            alt="MATIC"
                          />
                        </div>
                        <div className="flex flex-1 flex-col items-start justify-center ml-2">
                          <div className="flex items-center">
                            <div className="pr-1">MATIC</div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="flex cursor-pointer hover:bg-gray-50 pl-2 rounded rounded-full pt-1 pb-1 pr-1 mr-1 border"
                        onClick={e => handleCommonBase(e, 'DAI')}
                      >
                        <div className="flex items-center">
                          <img
                            src="https://assets.trustwalletapp.com/blockchains/polygon/assets/0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063/logo.png"
                            className="w-7 h-7"
                            alt="DAI"
                          />
                        </div>
                        <div className="flex flex-1 flex-col items-start justify-center ml-2">
                          <div className="flex items-center">
                            <div className="pr-1">DAI</div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="flex cursor-pointer hover:bg-gray-50 pl-2 rounded rounded-full pt-1 pb-1 pr-1 mr-1 border"
                        onClick={e => handleCommonBase(e, 'USDC')}
                      >
                        <div className="flex items-center">
                          <img
                            src="https://assets.trustwalletapp.com/blockchains/polygon/assets/0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174/logo.png"
                            className="w-7 h-7"
                            alt="USDC"
                          />
                        </div>
                        <div className="flex flex-1 flex-col items-start justify-center ml-2">
                          <div className="flex items-center">
                            <div className="pr-1">USDC</div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="flex cursor-pointer hover:bg-gray-50 pl-2 rounded rounded-full pt-1 pb-1 pr-1 mr-1 border"
                        onClick={e => handleCommonBase(e, 'WETH')}
                      >
                        <div className="flex items-center">
                          <img
                            src="https://assets.trustwalletapp.com/blockchains/polygon/assets/0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619/logo.png"
                            className="w-7 h-7"
                            alt="WETH"
                          />
                        </div>
                        <div className="flex flex-1 flex-col items-start justify-center ml-2">
                          <div className="flex items-center">
                            <div className="pr-1">WETH</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {results && results.length > 0 && (
                    <div className="mt-4 pt-3 border-t overflow-y-scroll h-80">
                      {results.map(result => {
                        return (
                          <div
                            className="flex items-center space-x-4 pt-2 pl-2 pb-2 hover:bg-gray-100 cursor-pointer"
                            key={result.symbol}
                            onClick={e => handleTokenSelect(e, result)}
                          >
                            <div className="flex-shrink-0">
                              <img
                                className="h-8 w-8 rounded-full"
                                src={result.imageURL}
                                alt=""
                              />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-medium text-gray-900 truncate">
                                {result.symbol}
                              </p>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
